const middleware = {}

middleware['wallet'] = require('../middleware/wallet.js')
middleware['wallet'] = middleware['wallet'].default || middleware['wallet']

export default middleware
